import axios from 'axios'

const WithdrawalService = {
  async get (params = {}) {
    return axios.get('wo/withdrawal/receivings', { params })
  },

  async histories (params = {}) {
    return axios.get('wo/reports/withdrawal/receiving-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('wo/exports/withdrawal/receivings', { params })
  },

  async show (id) {
    return axios.get(`wo/withdrawal/receivings/${id}`)
  },

  async post (params = {}) {
    return axios.post('wo/withdrawal/receivings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`wo/withdrawal/receivings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`wo/withdrawal/receivings/${data.id}`, { data })
  }
}

export default WithdrawalService
